{
  "Agent ready": "Agent ready",
  "Agent state": "Agent state",
  "Asking question": "Asking question",
  "Assign to AI": "Assign to AI",
  "Automation environment ID": "Automation environment ID",
  "Automation links": "Automation links",
  "Automation setup: %{status}": "Automation setup: %{status}",
  "Automation status": "Automation status",
  "Blocked": "Blocked",
  "Claimed": "Claimed",
  "Claimed by": "Claimed by",
  "Coding": "Coding",
  "Complete": "Complete",
  "Disabled": "Disabled",
  "Enable AI task assignment": "Enable AI task assignment",
  "Environment required": "Environment required",
  "Instance": "Instance",
  "In review": "In review",
  "Logs": "Logs",
  "Mark agent-ready": "Mark agent-ready",
  "Not under automation": "Not under automation",
  "Queued": "Queued",
  "Run": "Run",
  "The task was assigned to AI": "The task was assigned to AI",
  "TensorBuzz bot": "TensorBuzz bot",
  "TensorBuzz command": "TensorBuzz command",
  "Unknown": "Unknown",
  "Verifying": "Verifying",
  "Waiting for reply": "Waiting for reply",
  "A name is required": "A name is required",
  "Auth tokens": "Auth tokens",
  "Auth tokens let an AI bot or app act on your behalf through the API. Treat them like passwords — anyone with a token has your access until you revoke it.": "Auth tokens let an AI bot or app act on your behalf through the API. Treat them like passwords — anyone with a token has your access until you revoke it.",
  "Copy token": "Copy token",
  "Copy your token now. For your security, it will not be shown again.": "Copy your token now. For your security, it will not be shown again.",
  "Could not load auth token": "Could not load auth token",
  "Could not load auth tokens": "Could not load auth tokens",
  "Created %{date}": "Created %{date}",
  "Done": "Done",
  "Generate auth token": "Generate auth token",
  "Generate new token": "Generate new token",
  "Generate token": "Generate token",
  "Generate tokens an AI bot or app can use to act on your behalf through the API.": "Generate tokens an AI bot or app can use to act on your behalf through the API.",
  "Generating...": "Generating...",
  "Last used %{date}": "Last used %{date}",
  "Manage auth tokens": "Manage auth tokens",
  "Never used": "Never used",
  "Rename": "Rename",
  "Rename auth token": "Rename auth token",
  "Revoke": "Revoke",
  "Revoke this auth token? Apps using it will stop working immediately.": "Revoke this auth token? Apps using it will stop working immediately.",
  "Select the token above to copy it": "Select the token above to copy it",
  "The auth token was created": "The auth token was created",
  "The auth token was renamed": "The auth token was renamed",
  "The auth token was revoked": "The auth token was revoked",
  "Token copied to clipboard": "Token copied to clipboard",
  "Token name": "Token name",
  "You have no auth tokens yet": "You have no auth tokens yet",
  "Account not found": "Account not found",
  "Account": "Account",
  "Accounts": "Accounts",
  "Awesome Tasks": "Awesome Tasks",
  "Dashboard": "Dashboard",
  "Edit profile": "Edit profile",
  "Appearance": "Appearance",
  "Invoicing": "Invoicing",
  "Language": "Language",
  "Time": "Time",
  "Work": "Work",
  "Personalize the app to your preferences": "Personalize the app to your preferences",
  "Profile": "Profile",
  "Settings": "Settings",
  "Settings saved": "Settings saved",
  "Sign in to manage your settings": "Sign in to manage your settings",
  "Back to home": "Back to home",
  "Confirm": "Confirm",
  "Dark theme": "Dark theme",
  "Light theme": "Light theme",
  "Page not found": "Page not found",
  "The page you were looking for does not exist or has moved.": "The page you were looking for does not exist or has moved.",
  "Account created": "Account created",
  "Already have an account? Sign in": "Already have an account? Sign in",
  "Back to sign in": "Back to sign in",
  "Create account": "Create account",
  "Creating...": "Creating...",
  "Don't have an account? Sign up": "Don't have an account? Sign up",
  "Password must be at least 6 characters": "Password must be at least 6 characters",
  "Sign up": "Sign up",
  "Sign up failed": "Sign up failed",
  "Sign up with your email and a password": "Sign up with your email and a password",
  "Email and password are required": "Email and password are required",
  "Email is required": "Email is required",
  "Enter your email and password to continue": "Enter your email and password to continue",
  "Enter your email and we will send you a reset link": "Enter your email and we will send you a reset link",
  "Forgot password": "Forgot password",
  "Forgot password?": "Forgot password?",
  "Password reset email sent": "Password reset email sent",
  "Password reset request failed": "Password reset request failed",
  "Send reset link": "Send reset link",
  "Sending...": "Sending...",
  "Password": "Password",
  "Primary organization": "Primary organization",
  "Sign in": "Sign in",
  "Sign in failed": "Sign in failed",
  "Signed in": "Signed in",
  "Signing in...": "Signing in...",
  "Sign out": "Sign out",
  "Signed out": "Signed out",
  "Signing out...": "Signing out...",
  "Created": "Created",
  "Creditor": "Creditor",
  "Customer": "Customer",
  "Edit": "Edit",
  "Edit account": "Edit account",
  "Email": "Email",
  "First name": "First name",
  "Actions": "Actions",
  "Add timelog": "Add timelog",
  "Apply": "Apply",
  "Assigned users": "Assigned users",
  "Assign user": "Assign user",
  "Attach file": "Attach file",
  "Comment": "Comment",
  "Close": "Close",
  "Choose a task type.": "Choose a task type.",
  "Date": "Date",
  "Column Name": "Column Name",
  "Create": "Create",
  "Create New Task": "Create New Task",
  "Creating...": "Creating...",
  "Failed to load autoassigned users": "Failed to load autoassigned users",
  "Failed to load board": "Failed to load board",
  "Failed to load members": "Failed to load members",
  "Failed to load organization": "Failed to load organization",
  "Failed to load project": "Failed to load project",
  "Failed to load task types": "Failed to load task types",
  "Failed to load tasks": "Failed to load tasks",
  "Edit assignment": "Edit assignment",
  "Add to Board": "Add to Board",
  "Board": "Board",
  "Board placement": "Board placement",
  "Board not found.": "Board not found.",
  "Boards": "Boards",
  "Adding Board...": "Adding Board...",
  "Column: %{columnName}": "Column: %{columnName}",
  "Loading Boards...": "Loading Boards...",
  "Remove Board placement": "Remove Board placement",
  "Remove from Board": "Remove from Board",
  "Remove": "Remove",
  "Remove this task from %{boardName}?": "Remove this task from %{boardName}?",
  "Removing...": "Removing...",
  "Offline": "Offline",
  "Pending": "Pending",
  "Syncing": "Syncing",
  "Syncing…": "Syncing…",
  "Failed": "Failed",
  "Conflicted": "Conflicted",
  "Retry": "Retry",
  "Search projects and Boards...": "Search projects and Boards...",
  "This task is not on any Boards.": "This task is not on any Boards.",
  "Edit invoice group": "Edit invoice group",
  "Edit file": "Edit file",
  "Edit timelog": "Edit timelog",
  "File": "File",
  "File not found": "File not found",
  "General": "General",
  "Details": "Details",
  "Open file": "Open file",
  "Resource": "Resource",
  "Uploaded by": "Uploaded by",
  "Edit project": "Edit project",
  "Edit task": "Edit task",
  "Edit user": "Edit user",
  "Autoassigned users": "Autoassigned users",
  "Invoice group not found": "Invoice group not found",
  "Invoice groups": "Invoice groups",
  "Invoices": "Invoices",
  "Loading...": "Loading...",
  "Name": "Name",
  "No invoice groups found": "No invoice groups found",
  "No invoices were linked to this invoice group": "No invoices were linked to this invoice group",
  "Cancel": "Cancel",
  "Delete": "Delete",
  "Delete file": "Delete file",
  "No assigned users": "No assigned users",
  "No users assigned to this task": "No users assigned to this task",
  "User added to task": "User added to task",
  "User removed from task": "User removed from task",
  "You": "You",
  "No files found": "No files found",
  "No invoices found": "No invoices found",
  "New account": "New account",
  "New invoice group": "New invoice group",
  "New project": "New project",
  "Project": "Project",
  "Project not found": "Project not found",
  "Priority": "Priority",
  "New task": "New task",
  "New timelog": "New timelog",
  "New Column": "New Column",
  "New user": "New user",
  "No accounts found": "No accounts found",
  "Not signed in": "Not signed in",
  "No tasks in this column": "No tasks in this column",
  "No matching tasks found": "No matching tasks found",
  "State": "State",
  "Save": "Save",
  "Search": "Search",
  "All states": "All states",
  "All creditors": "All creditors",
  "All debitors": "All debitors",
  "All invoice types": "All invoice types",
  "Clear filters": "Clear filters",
  "Debitor": "Debitor",
  "Refresh": "Refresh",
  "Sort": "Sort",
  "Task not found": "Task not found",
  "Time": "Time",
  "Timelog": "Timelog",
  "Timelog deleted": "Timelog deleted",
  "Timelog not found": "Timelog not found",
  "Time transport": "Time transport",
  "Time Logs Dashboard": "Time Logs Dashboard",
  "More filters": "More filters",
  "Saving...": "Saving...",
  "Search accounts...": "Search accounts...",
  "Invoicing status": "Invoicing status",
  "Invoiced only": "Invoiced only",
  "No timelogs found": "No timelogs found",
  "No timelogs found for this period.": "No timelogs found for this period.",
  "No previous period": "No previous period",
  "Uninvoiced only": "Uninvoiced only",
  "Task": "Task",
  "Task details": "Task details",
  "Task ID": "Task ID",
  "Task Type": "Task Type",
  "Task not found on this board.": "Task not found on this board.",
  "Timelogs": "Timelogs",
  "The assignment was saved": "The assignment was saved",
  "The file was deleted": "The file was deleted",
  "The timelog was saved": "The timelog was saved",
  "Uploaded files": "Uploaded files",
  "Time (minutes)": "Time (minutes)",
  "Time transport (minutes)": "Time transport (minutes)",
  "Transport length": "Transport length",
  "Transport length (km)": "Transport length (km)",
  "Untitled column": "Untitled column",
  "Untitled task": "Untitled task",
  "Last name": "Last name",
  "Updated": "Updated",
  "User": "User",
  "User not found": "User not found",
  "Organization": "Organization",
  "Organization not found": "Organization not found",
  "Delete organization": "Delete organization",
  "Payment info": "Payment info",
  "Delivery address": "Delivery address",
  "Delivery zip code": "Delivery zip code",
  "Delivery city": "Delivery city",
  "Delivery country": "Delivery country",
  "Invoice address": "Invoice address",
  "Invoice zip code": "Invoice zip code",
  "Invoice city": "Invoice city",
  "Invoice country": "Invoice country",
  "VAT no": "VAT no",
  "Edit organization": "Edit organization",
  "New organization": "New organization",
  "The organization was deleted": "The organization was deleted",
  "The organization was saved": "The organization was saved",
  "Amount": "Amount",
  "Amount currency": "Amount currency",
  "Edit invoice line": "Edit invoice line",
  "Invoice line not found": "Invoice line not found",
  "New invoice line": "New invoice line",
  "Quantity": "Quantity",
  "The invoice line was saved": "The invoice line was saved",
  "Title": "Title",
  "Edit comment": "Edit comment",
  "New comment": "New comment",
  "The comment was saved": "The comment was saved",
  "Comment not found": "Comment not found",
  "Changed the task status to %{state}": "Changed the task status to %{state}",
  "Comments": "Comments",
  "No comments found": "No comments found",
  "Add invoice line": "Add invoice line",
  "Amount total": "Amount total",
  "Amount VAT": "Amount VAT",
  "Amounts": "Amounts",
  "Finish": "Finish",
  "ID": "ID",
  "Invoice %{number}": "Invoice %{number}",
  "Invoice lines": "Invoice lines",
  "Invoice no": "Invoice no",
  "Invoice not found": "Invoice not found",
  "Invoice type": "Invoice type",
  "Manage": "Manage",
  "More": "More",
  "Mine": "Mine",
  "No": "No",
  "No invoice groups": "No invoice groups",
  "No invoice lines": "No invoice lines",
  "No VAT": "No VAT",
  "Payment date": "Payment date",
  "Register as paid": "Register as paid",
  "Register as sent": "Register as sent",
  "All": "All",
  "Load more": "Load more",
  "%{count} active members": "%{count} active members",
  "%{count} assigned": "%{count} assigned",
  "%{count} comments": "%{count} comments",
  "%{count} projects": "%{count} projects",
  "%{count} timelogs": "%{count} timelogs",
  "Last activity: %{date}": "Last activity: %{date}",
  "Manage organizations, customers and creditors": "Manage organizations, customers and creditors",
  "No activity yet": "No activity yet",
  "No organizations found": "No organizations found",
  "Organizations": "Organizations",
  "Search organizations by name...": "Search organizations by name...",
  "Search organizations...": "Search organizations...",
  "Date from": "Date from",
  "Date range": "Date range",
  "Date to": "Date to",
  "Delete Column": "Delete Column",
  "Delete Task": "Delete Task",
  "Delete the column %{name}?": "Delete the column %{name}?",
  "Delete this task?": "Delete this task?",
  "Delete this timelog?": "Delete this timelog?",
  "Manage and track team billable hours": "Manage and track team billable hours",
  "Loading dashboard...": "Loading dashboard...",
  "Search by comment...": "Search by comment...",
  "No users found": "No users found",
  "No organization": "No organization",
  "Search users...": "Search users...",
  "Users": "Users",
  "After tax (40%)": "After tax (40%)",
  "Distance": "Distance",
  "Due soon": "Due soon",
  "Earned": "Earned",
  "Entries": "Entries",
  "Enter a duration like 1h 5m, 30s or 1.5": "Enter a duration like 1h 5m, 30s or 1.5",
  "1h 5m, 30s or 1.5": "1h 5m, 30s or 1.5",
  "Hours": "Hours",
  "h": "h",
  "Invoiced": "Invoiced",
  "Billing progress": "Billing progress",
  "Estimated earnings": "Estimated earnings",
  "Invoiced %{invoiced} of %{total}%{currency}": "Invoiced %{invoiced} of %{total}%{currency}",
  "Internal": "Internal",
  "Overview": "Overview",
  "Transport": "Transport",
  "Transport earned": "Transport earned",
  "Total earned": "Total earned",
  "Rate": "Rate",
  "Status": "Status",
  "Unknown user": "Unknown user",
  "Unknown date": "Unknown date",
  "Untitled entry": "Untitled entry",
  "%{amount} %{currency}": "%{amount} %{currency}",
  "%{amount} %{currency}/h": "%{amount} %{currency}/h",
  "%{date} · %{user}": "%{date} · %{user}",
  "Active": "Active",
  "Finished": "Finished",
  "Inactive": "Inactive",
  "Browse, search and manage projects": "Browse, search and manage projects",
  "Delete project: %{name}?": "Delete project: %{name}?",
  "Members": "Members",
  "No autoassigned users found": "No autoassigned users found",
  "No members found": "No members found",
  "No projects found": "No projects found",
  "No projects yet.": "No projects yet.",
  "Project deleted": "Project deleted",
  "Projects": "Projects",
  "Search projects by name...": "Search projects by name...",
  "Search projects...": "Search projects...",
  "This will also remove the project's boards, tasks, task types and user assignments.": "This will also remove the project's boards, tasks, task types and user assignments.",
  "Closed": "Closed",
  "No tasks found": "No tasks found",
  "No task type": "No task type",
  "No task types found": "No task types found",
  "No board column": "No board column",
  "Unnamed project": "Unnamed project",
  "Unnamed task": "Unnamed task",
  "Unnamed task type": "Unnamed task type",
  "Open": "Open",
  "Confirmed": "Confirmed",
  "Waiting": "Waiting",
  "Loading board...": "Loading board...",
  "Column": "Column",
  "Column actions": "Column actions",
  "Status color": "Status color",
  "Add task": "Add task",
  "Edit Column": "Edit Column",
  "Issue title": "Issue title",
  "Please enter a column name.": "Please enter a column name.",
  "Please enter a title.": "Please enter a title.",
  "Add context or acceptance details...": "Add context or acceptance details...",
  "Description": "Description",
  "e.g. Backlog, In Review": "e.g. Backlog, In Review",
  "Confirm delete": "Confirm delete",
  "Credit": "Credit",
  "Debit": "Debit",
  "Deleting...": "Deleting...",
  "Draft": "Draft",
  "Edit invoice %{id}": "Edit invoice %{id}",
  "Enter details": "Enter details",
  "Highest amount": "Highest amount",
  "Invoice number A-Z": "Invoice number A-Z",
  "Invoice number Z-A": "Invoice number Z-A",
  "Lowest amount": "Lowest amount",
  "New invoice": "New invoice",
  "Newest first": "Newest first",
  "Name A-Z": "Name A-Z",
  "Name Z-A": "Name Z-A",
  "Oldest first": "Oldest first",
  "Open, confirmed, and waiting": "Open, confirmed, and waiting",
  "Paid": "Paid",
  "Purchase": "Purchase",
  "Search invoices...": "Search invoices...",
  "Sent": "Sent",
  "Show": "Show",
  "State A-Z": "State A-Z",
  "Type": "Type",
  "Type A-Z": "Type A-Z",
  "Search tasks...": "Search tasks...",
  "Search tasks by name or description...": "Search tasks by name or description...",
  "Task actions": "Task actions",
  "Tasks": "Tasks",
  "Task deleted": "Task deleted",
  "Delete task: %{name}?": "Delete task: %{name}?",
  "Track and manage tasks across projects": "Track and manage tasks across projects",
  "All projects": "All projects",
  "All users": "All users",
  "Any": "Any",
  "Daily timelogs aggregated for the selected range": "Daily timelogs aggregated for the selected range",
  "Export CSV": "Export CSV",
  "Exporting...": "Exporting...",
  "Exported %{count} timelogs": "Exported %{count} timelogs",
  "Filter, export and bulk-invoice tracked time": "Filter, export and bulk-invoice tracked time",
  "Mark all invoiced": "Mark all invoiced",
  "Mark all matching timelogs as invoiced?": "Mark all matching timelogs as invoiced?",
  "Marked %{count} timelogs as invoiced": "Marked %{count} timelogs as invoiced",
  "Marking...": "Marking...",
  "Not invoiced": "Not invoiced",
  "Total hours": "Total hours",
  "Transport hours": "Transport hours",
  "Invoiced / not invoiced": "Invoiced / not invoiced",
  "Currency": "Currency",
  "Edit invoice": "Edit invoice",
  "Work status": "Work status",
  "%{percent} vs %{range}": "%{percent} vs %{range}",
  "%{from} - %{to}": "%{from} - %{to}",
  "Yes": "Yes",
  "Choose file": "Choose file",
  "No file chosen": "No file chosen",
  "A file upload is required": "A file upload is required",
  "Could not load the form": "Could not load the form",
  "Could not save the bill": "Could not save the bill",
  "Could not save the file": "Could not save the file",
  "File uploads are only supported on the web": "File uploads are only supported on the web",
  "New file": "New file",
  "New bill": "New bill",
  "New creditor": "New creditor",
  "No creditors found": "No creditors found",
  "Select creditor": "Select creditor",
  "Uploaded file": "Uploaded file",
  "Add uninvoiced timelogs": "Add uninvoiced timelogs",
  "No uploaded files": "No uploaded files",
  "Delete invoice": "Delete invoice",
  "Delete invoice line": "Delete invoice line",
  "Delete this invoice?": "Delete this invoice?",
  "Delete this invoice line?": "Delete this invoice line?",
  "Added %{count} uninvoiced timelogs": "Added %{count} uninvoiced timelogs",
  "Invoice finished": "Invoice finished",
  "Invoice registered as sent": "Invoice registered as sent",
  "Invoice registered as paid": "Invoice registered as paid",
  "PDF": "PDF",
  "The invoice line was deleted": "The invoice line was deleted",
  "Deactivated": "Deactivated",
  "Deadline at": "Deadline at",
  "Delete this user?": "Delete this user?",
  "Delete user": "Delete user",
  "Invited": "Invited",
  "Last login: %{date}": "Last login: %{date}",
  "Member": "Member",
  "Never": "Never",
  "The user was deleted": "The user was deleted",
  "Add": "Add",
  "Add task type": "Add task type",
  "Add user": "Add user",
  "Could not load project members": "Could not load project members",
  "Members for %{projectName}": "Members for %{projectName}",
  "No members yet": "No members yet",
  "User added to project": "User added to project",
  "User removed from project": "User removed from project",
  "Choose profile picture": "Choose profile picture",
  "Could not read the selected image": "Could not read the selected image",
  "Please choose an image file": "Please choose an image file",
  "Profile picture": "Profile picture",
  "haya_select.no_options_found": "No options found",
  "haya_select.nothing_selected": "Nothing selected",
  "haya_select.pagination_page_of_pages": "Page %{page} of %{totalPages}",
  "haya_select.search_dot_dot_dot": "Search...",
  "Conflicts": "Conflicts",
  "Database connection timeout": "Database connection timeout",
  "Last synced": "Last synced",
  "Next retry": "Next retry",
  "Next retry %{date}": "Next retry %{date}",
  "No network connection": "No network connection",
  "Project sync settings are incomplete": "Project sync settings are incomplete",
  "Queued changes": "Queued changes",
  "Reason": "Reason",
  "Rejected changes": "Rejected changes",
  "Sync failed": "Sync failed",
  "Sync request rejected": "Sync request rejected",
  "Sync sign-in required": "Sync sign-in required",
  "Sync status": "Sync status",
  "%{count} changes queued": "%{count} changes queued",
  "%{count} changes rejected": "%{count} changes rejected",
  "%{count} conflicts": "%{count} conflicts",
  "%{date} last synced": "%{date} last synced"
}
